import type { ChangeVehicleState } from '../types';

export const incrementFetchCount = (state: ChangeVehicleState): number => {
    return (state.activeFetchCount || 0) + 1;
};

export const decrementFetchCount = (state: ChangeVehicleState): number => {
    return Math.max(0, (state.activeFetchCount || 0) - 1);
};
